import {
  BACK_FROM_CURRENT_SCREEN,
  GET_MAIN_TOPICS,
  GET_SUB_TOPICS,
  HIDDEN_QUESTIONS,
  LIST_OF_QUESTIONS,
  QUESTION_BY_ID,
  RESET_HIDDEN_QUESTIONS,
  SHOW_MAIN_TOPICS,
  SHOW_SUB_TOPICS,
  SUBMIT_QUESTION_TEST_RESPONSE,
} from './ActionTypes';

export const getListOfMainTopics = (userId, errorSnackbar = () => {
}) => {
  return {
    type: GET_MAIN_TOPICS,
    userId: userId,
    errorSnackbar,
  };
};

export const showListOfMainTopics = (mainTopicsArray) => {
  return {
    type: SHOW_MAIN_TOPICS,
    mainTopicsArray: mainTopicsArray,
  };
};

export const getListOfSubTopics = (
  subTopicRequestBody,
  success = () => {
  },
  errorSnackbar = () => {
  },
) => {
  return {
    type: GET_SUB_TOPICS,
    subTopicRequestBody: subTopicRequestBody,
    success,
    errorSnackbar,
  };
};

export const showListOfSubTopics = (subTopicsArray) => {
  return {
    type: SHOW_SUB_TOPICS,
    subTopicsArray: subTopicsArray,
  };
};

export const getQuestionByTopicId = (
  questionBody,
  questionId,
  errorSnackbar = () => {
  },
) => {
  return {
    type: QUESTION_BY_ID,
    questionBody: questionBody,
    questionId,
    errorSnackbar,
  };
};

export const listOFQuestions = (questionArray) => {
  return {
    type: LIST_OF_QUESTIONS,
    questionArray: questionArray,
  };
};

export const resetAllHiddenQuestions = (
  resetHiddenQuestionsBody,
  success,
  errorSnackbar = () => {
  },
) => {
  return {
    type: RESET_HIDDEN_QUESTIONS,
    resetHiddenQuestionsBody: resetHiddenQuestionsBody,
    success,
    errorSnackbar,
  };
};

export const backTo_Topics = () => {
  return {
    type: BACK_FROM_CURRENT_SCREEN,
  };
};
export const hideQuestion = (testResponseData, callback = () => {
}) => {
  return {
    type: HIDDEN_QUESTIONS,
    testResponseData: testResponseData,
    callback,
  };
};

export const submitTestResponse = (
  testResponseData,
  back,
  callback = () => {
  },
) => {
  return {
    type: SUBMIT_QUESTION_TEST_RESPONSE,
    testResponseData: testResponseData,
    back,
    callback,
  };
};
